import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import { useLazyQuery } from '@apollo/client'

// import { graphqlClient } from '@shared/components/queryGraphql'
import { getCookie } from '@shared/utils'
import { GET_POLL_BY_ID_FRONT } from '@graphql/poll/poll.query'

const PollStyle = dynamic(() => import('@shared/components/multiPoll/pollStyle'))
const SimplePoll = dynamic(() => import('@shared/components/multiPoll/simplePoll'))
const QuePoll = dynamic(() => import('@shared/components/multiPoll/quePoll'))
const VerticalPoll = dynamic(() => import('@shared/components/multiPoll/verticalPoll'))
const ReactPoll = dynamic(() => import('@shared/components/multiPoll/reactPoll'))

function MultiPoll({ id, data, className, autoShowNextPoll = true }) {
  const [ind, setInd] = useState(data?.aSlides?.length > 0 ? { i: 0 } : { i: undefined })
  const pollData = useRef(data)
  const poll = pollData.current?.aSlides?.[ind?.i]
  // const poll = pollData.current?.aSlides[1]

  const [getPollAPI] = useLazyQuery(GET_POLL_BY_ID_FRONT)

  useEffect(() => {
    if (id) getPollData(id)
  }, [id])

  useEffect(() => {
    if (pollData.current?._id) {
      function handleChangePoll() {
        setTimeout(() => {
          setInd((j) => {
            if (j?.i + 1 < pollData?.current?.aSlides?.length) {
              return { i: j?.i + 1 }
            } else {
              autoShowNextPoll && getPollData(pollData?.current?._id)
              return j
            }
          })
        }, 1500)
      }
      if (autoShowNextPoll) {
        const i = pollData.current?.aSlides?.findIndex(e => !getCookie(e?._id))
        if ((i !== -1) && (pollData.current?.aSlides?.length > i)) { // Check poll is answered then show next poll
          setInd({ i: i })
        }
      }
      window.addEventListener(pollData.current?._id, handleChangePoll)
      return () => window.removeEventListener(pollData.current?._id, handleChangePoll)
    }
  }, [pollData.current])

  async function getPollData(_id) {
    try {
      const sFingerPrint = localStorage.getItem('UPId')
      const { data } = await getPollAPI({ variables: { input: { _id: _id || id, sFingerPrint } }, fetchPolicy: 'network-only' })
      if (data?.getPollByIdFront) {
        pollData.current = data?.getPollByIdFront || {}
        setInd({ i: 0 })
      }
    } catch (error) {
      console.log(error)
    }
  }

  function handleNextSlide(currentSlide, index) {
    if (getCookie(currentSlide?._id)) setInd({ i: index })
  }

  function getPoll() {
    const pClass = pollData.current?.aSlides?.length > 1 ? 'pt-4' : ''
    if (poll?.eSlideType === 'sp' || poll?.eSlideType === 'ip') {
      return (
        <SimplePoll
          className={`${className || ''} ${pClass}`}
          poll={{ ...poll, dEndDate: pollData.current?.dEndDate, parentId: pollData.current?._id }}
        />
      )
    } else if (poll?.eSlideType === 'mp') {
      return (
        <QuePoll
          className={`${className || ''} ${pClass}`}
          poll={{ ...poll, dEndDate: pollData.current?.dEndDate, parentId: pollData.current?._id }}
        />
      )
    } else if (poll?.eSlideType === 'vs') {
      return (
        <VerticalPoll
          className={`${className || ''} ${pClass}`}
          poll={{ ...poll, dEndDate: pollData.current?.dEndDate, parentId: pollData.current?._id }}
        />
      )
    } else if (poll?.eSlideType === 'rp') {
      return (
        <ReactPoll
          className={`${className || ''} ${pClass}`}
          poll={{ ...poll, dEndDate: pollData.current?.dEndDate, parentId: pollData.current?._id }}
        />
      )
    } else return null
  }

  return (
    <div className="position-relative" id={pollData.current?._id}>
      {pollData.current?.aSlides?.length > 1 && (
        <PollStyle>
          {(pollStyle) => (
            <div className={`${pollStyle.pollDot} ${poll?.eSlideType === 'vs' ? pollStyle.vsPoll : 'w-100'} d-flex px-1 position-absolute mx-auto mw-100 start-50 translate-middle-x`}>
              {pollData.current?.aSlides?.map((p, i) => (
                <div
                  key={p?._id}
                  className={`${pollStyle.dot} ${i === ind?.i ? pollStyle.active : ''} ${i === (ind?.i + 1) ? 'c-pointer' : ''} flex-grow-1 rounded-pill mx-1 position-relative`}
                  onClick={() => {
                    if (i === (ind?.i + 1)) handleNextSlide(pollData.current?.aSlides[ind?.i], (ind?.i + 1)) // for Next
                    else if (i < ind?.i) handleNextSlide(pollData.current?.aSlides[i], i) // For previous
                  }}
                />
              ))}
            </div>
          )}
        </PollStyle>
      )}
      {getPoll()}
    </div>
  )
}

MultiPoll.propTypes = {
  id: PropTypes.string,
  data: PropTypes.object,
  className: PropTypes.string,
  autoShowNextPoll: PropTypes.bool
}
export default React.memo(MultiPoll)
